<template>
  <div class="card-wrapper">
    <div v-if="loading" class="loading">
      <q-spinner color="primary" size="2.5em" />
    </div>
    <slot v-else />
  </div>
</template>

<script>
export default {
  props: {
    loading: Boolean
  }
}
</script>

<style lang="stylus" scoped>
.card-wrapper {
  padding 20px
  box-shadow 0 2px 12px rgba(0,0,0,.18)
  background-color white

  > .loading {
    height 100%
    width 100%
    display flex
    justify-content center
    align-items center
  }
}
</style>
